<script>
import { number } from "@coders-tm/vue-number-format";
import { required } from "vuelidate/lib/validators";
import { extend } from "vee-validate";

import Vue from "vue";
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import itemsAPI from "../../../services/items/itemsAPI";
import Swal from "sweetalert2";

/**
 * Form elements component
 */
 
export default {
  page: {
    title: "Estandares",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    number,
  },

  data() {
    return {
      title: "Registro de Ítems",
      items: [
       
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Registro de ítems",
          active: true,
        },
      ],
      submitted: false,
      showNotification: false,
      message: "",


      estandarD: {
        sequence: null,
        description: null,
        value: null,
        obligatory_UPA: 1,
        status: 1,
        url: null,
        obligatory_groupI: 1,
        obligatory_groupII: 1,
        obligatory_groupIII: 1,
      },
    };
  },

  validations: {
    estandarD: {
      sequence: {
        required,
      },
      description: {
        required,
      },
      value: {
        required,
      },
      obligatory_UPA: {
        required,
      },
      obligatory_groupI: {
        required,
      },
      obligatory_groupII: {
        required,
      },
      obligatory_groupIII: {
        required,
      },
      status: {
        required,
      },
      url: {
        required,
      },
    },
  },

  methods: {
    save() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
        console.group("Data invalid: ");
        console.log('Secuencia', this.$v.estandarD.sequence);
        console.log('Descripción', this.$v.estandarD.description);
        console.log('Valor', this.$v.estandarD.value);
        console.log('UPA', this.$v.estandarD.obligatory_UPA);
        console.log('Status', this.$v.estandarD.status);
        console.log('URL', this.$v.estandarD.url);
        console.log('Grupo I', this.$v.estandarD.obligatory_groupI);
        console.log('Grupo II', this.$v.estandarD.obligatory_groupII);
        console.log('Grupo III', this.$v.estandarD.obligatory_groupIII);
        console.groupEnd();
        return;
      } else {

        console.group("Data que será registrada: ");
        console.log(this.estandarD);
        console.groupEnd();

        itemsAPI
          .createItems(this.estandarD)
          .then((resp) => {
            Swal.fire({
                title: "Se ha registrado el ítem con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            console.log(resp);
             this.$router.go(-1);
          })
          .catch((err) => {
            console.log("Error al guardar Items: ", err);
          });
          
      }

      /* itemsAPI.createItems({
        sequence: this.estandarD.sequence,
        description:  this.estandarD.description,
        value: this.estandarD.value,
        obligatory_UPA: this.estandarD.obligatory_UPA,
        status: this.estandarD.status,
        url: this.estandarD.url,
        obligatory_groupI: this.estandarD.obligatory_groupI,
        obligatory_groupII: this.estandarD.obligatory_groupII,
        obligatory_groupIII: this.estandarD.obligatory_groupIII,
         })
        .then((response) => {
         // this.$router.go(-1);
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        }); */
    },

    goBack() {
      this.$router.go(-1);
    },
   
  },
  mounted() {

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h4 class="header-title mb-4">Ítems</h4>
              </div>

              <div class="col-6 text-right">
                <div
                  @click="goBack"
                  class="btn btn-secondary m-l-5 ml-1"
                  id="tooltip"
                >
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <div class="row">
              <div class="col-3"></div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-body">
                    <form
                      class="form-horizonta form-group"
                      @submit.prevent="save"
                      role="form"
                    >
                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Item"
                        label-for="items"
                      >
                        <b-form-input
                          type="text"
                          id="items"
                          placeholder=""
                          v-model="estandarD.sequence"
                          :class="{
                            'is-invalid':
                              $v.estandarD.sequence.$error && submitted,
                          }"
                        ></b-form-input>
                        <div v-if="submitted && $v.estandarD.sequence.$error">
                          <small
                            v-if="!$v.estandarD.sequence.required"
                            class="text-danger"
                          >
                            <b>El items es requerido</b>
                          </small>
                        </div>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Nombre"
                        label-for="name"
                      >
                        <b-form-input
                          type="text"
                          id="name"
                          placeholder=""
                          v-model="estandarD.description"
                          required
                          :class="{
                            'is-invalid':
                              $v.estandarD.description.$error && submitted,
                          }"
                        ></b-form-input>
                        <div
                          v-if="submitted && $v.estandarD.description.$error"
                        >
                          <small
                            v-if="!$v.estandarD.description.required"
                            class="text-danger"
                          >
                            <b>La descripción es requerida</b>
                          </small>
                        </div>
                      </b-form-group>
                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Valor"
                        label-for="value"
                      >
                        <b-form-input
                          type="tel"
                          id="value"
                          placeholder=""
                          v-model="estandarD.value"
                          required
                          :class="{
                            'is-invalid':
                              $v.estandarD.value.$error && submitted,
                          }"
                        ></b-form-input>

                        <div v-if="submitted && $v.estandarD.value.$error">
                          <small
                            v-if="!$v.estandarD.value.required"
                            class="text-danger"
                          >
                            <b>El valor es requerido</b>
                          </small>
                        </div>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Obligatorio UPA"
                        id="obligatory_UPA"
                        label-for="obligatory_UPA"
                      >
                        <select
                          id="obligatory_UPA"
                          class="form-control"
                          v-model="estandarD.obligatory_UPA"
                        >
                          <option :value="1">Si</option>
                          <option :value="0">No</option>
                        </select>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Estado"
                        id="estado"
                        label-for="status"
                      >
                        <select
                          id="status"
                          class="form-control"
                          v-model="estandarD.status"
                        >
                          <option :value="1">Activo</option>
                          <option :value="0">Inactivo</option>
                        </select>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="URL"
                        id="url"
                        label-for="url"
                      >
                        <b-form-input
                          type="text"
                          id="url"
                          placeholder=""
                          v-model="estandarD.url"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Obligatorio grupo 1"
                        label-for="obligatory_1"
                      >
                        <select
                          id="obligatory_1"
                          class="form-control"
                          v-model="estandarD.obligatory_groupI"
                        >
                          <option :value="1">Si</option>
                          <option :value="0">No</option>
                        </select>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Obligatorio grupo 2"
                        label-for="obligatory_2"
                      >
                        <select
                          id="obligatory_2"
                          class="form-control"
                          v-model="estandarD.obligatory_groupII"
                        >
                          <option :value="1">Si</option>
                          <option :value="0">No</option>
                        </select>
                      </b-form-group>

                      <b-form-group
                        label-cols-sm="4"
                        label-cols-lg="3"
                        label="Obligatorio grupo 3"
                        label-for="obligatory_3"
                      >
                        <select
                          id="obligatory_3"
                          class="form-control"
                          v-model="estandarD.obligatory_groupIII"
                        >
                          <option :value="1">Si</option>
                          <option :value="0">No</option>
                        </select>
                      </b-form-group>

                      <div class="form-group text-right m-b-0">
                        <button id="save" class="btn btn-primary" type="submit">
                          Guardar
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary m-l-5 ml-1"
                          @click="goBack"
                        >
                          Cancelar
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
